import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useUpdateCustomFieldDefinition = function () {
    return useApiCall(function (signal, payload) {
        return api.customFields.apiCustomFieldDefinitionIdPut(payload.id, payload, { signal: signal });
    }, null, true, [], { success: 'Custom field updated.' });
};
